import {
  FETCH_DATEWISE_SALE_REQUEST,
  FETCH_DATEWISE_SALE_SUCCESS,
  FETCH_DATEWISE_SALE_FAILURE,
} from '../actions/dateWiseReportingActions';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const dateWiseSaleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATEWISE_SALE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DATEWISE_SALE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_DATEWISE_SALE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
